export default [
  ['/getting-started/', 'Getting Started'],
  ['/backends/', 'Backends'],
  ['/ui-components/', 'UI Components'],
];



// WEBPACK FOOTER //
// ./src/nav-sections.js